import React from 'react';

class siren extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_241_813)">
          <path
            d="M40 74C58.7777 74 74 58.7777 74 40C74 21.2223 58.7777 6 40 6C21.2223 6 6 21.2223 6 40C6 58.7777 21.2223 74 40 74Z"
            fill="#F7F4F1"
          />
          <path
            d="M40.0002 74.8C20.8122 74.8 5.2002 59.188 5.2002 40C5.2002 20.812 20.8122 5.19995 40.0002 5.19995C59.1882 5.19995 74.8002 20.812 74.8002 40C74.8002 59.188 59.1882 74.8 40.0002 74.8ZM40.0002 6.79995C21.6942 6.79995 6.8002 21.694 6.8002 40C6.8002 58.306 21.6942 73.2 40.0002 73.2C58.3062 73.2 73.2002 58.306 73.2002 40C73.2002 21.694 58.3062 6.79995 40.0002 6.79995Z"
            fill="#84827E"
          />
          <path
            d="M40.0802 28.606C39.3642 28.606 38.7842 29.186 38.7842 29.902C38.7842 30.618 39.3642 31.198 40.0802 31.198C40.7962 31.198 41.3762 30.618 41.3762 29.902C41.3762 29.186 40.7962 28.606 40.0802 28.606Z"
            fill="url(#paint0_linear_241_813)"
          />
          <path
            d="M35.6686 32.336C36.2886 31.978 36.5006 31.186 36.1426 30.566C35.7846 29.946 34.9926 29.734 34.3726 30.092C33.7526 30.45 33.5406 31.242 33.8986 31.862C34.2566 32.482 35.0486 32.694 35.6686 32.336Z"
            fill="url(#paint1_linear_241_813)"
          />
          <path
            d="M31.9421 33.758C31.3221 33.4 30.5301 33.612 30.1721 34.232C29.8141 34.852 30.0261 35.644 30.6461 36.002C31.2661 36.36 32.0581 36.148 32.4161 35.528C32.7741 34.908 32.5621 34.116 31.9421 33.758Z"
            fill="url(#paint2_linear_241_813)"
          />
          <path
            d="M28.6064 39.92C28.6064 40.636 29.1864 41.216 29.9024 41.216C30.6184 41.216 31.1984 40.636 31.1984 39.92C31.1984 39.204 30.6184 38.624 29.9024 38.624C29.1864 38.624 28.6064 39.204 28.6064 39.92Z"
            fill="url(#paint3_linear_241_813)"
          />
          <path
            d="M30.566 43.8579C29.946 44.2159 29.734 45.0079 30.092 45.6279C30.45 46.2479 31.242 46.4599 31.862 46.1019C32.482 45.7439 32.694 44.9519 32.336 44.3319C31.978 43.7119 31.186 43.4999 30.566 43.8579Z"
            fill="url(#paint4_linear_241_813)"
          />
          <path
            d="M36.002 49.352C36.36 48.732 36.148 47.94 35.528 47.582C34.908 47.224 34.116 47.436 33.758 48.056C33.4 48.676 33.612 49.468 34.232 49.826C34.852 50.184 35.644 49.972 36.002 49.352Z"
            fill="url(#paint5_linear_241_813)"
          />
          <path
            d="M39.92 48.804C39.204 48.804 38.624 49.384 38.624 50.1C38.624 50.816 39.204 51.396 39.92 51.396C40.636 51.396 41.216 50.816 41.216 50.1C41.216 49.384 40.636 48.804 39.92 48.804V48.804Z"
            fill="url(#paint6_linear_241_813)"
          />
          <path
            d="M44.3326 47.664C43.7126 48.022 43.5006 48.814 43.8586 49.434C44.2166 50.054 45.0086 50.266 45.6286 49.908C46.2486 49.55 46.4606 48.758 46.1026 48.138C45.7446 47.518 44.9526 47.306 44.3326 47.664Z"
            fill="url(#paint7_linear_241_813)"
          />
          <path
            d="M49.3522 43.998C48.7322 43.64 47.9402 43.852 47.5822 44.472C47.2242 45.092 47.4362 45.884 48.0562 46.242C48.6762 46.6 49.4682 46.388 49.8262 45.768C50.1842 45.148 49.9722 44.356 49.3522 43.998Z"
            fill="url(#paint8_linear_241_813)"
          />
          <path
            d="M50.0987 38.7859C49.3827 38.7859 48.8027 39.3659 48.8027 40.0819C48.8027 40.7979 49.3827 41.3779 50.0987 41.3779C50.8147 41.3779 51.3947 40.7979 51.3947 40.0819C51.3947 39.3659 50.8147 38.7859 50.0987 38.7859V38.7859Z"
            fill="url(#paint9_linear_241_813)"
          />
          <path
            d="M49.4343 36.1419C50.0543 35.7839 50.2663 34.9919 49.9083 34.3719C49.5503 33.7519 48.7583 33.5399 48.1383 33.8979C47.5183 34.2559 47.3063 35.0479 47.6643 35.6679C48.0223 36.2879 48.8143 36.4999 49.4343 36.1419Z"
            fill="url(#paint10_linear_241_813)"
          />
          <path
            d="M45.7682 30.1718C45.1482 29.8138 44.3562 30.0258 43.9982 30.6458C43.6402 31.2658 43.8522 32.0578 44.4722 32.4158C45.0922 32.7738 45.8842 32.5618 46.2422 31.9418C46.6002 31.3218 46.3882 30.5298 45.7682 30.1718Z"
            fill="url(#paint11_linear_241_813)"
          />
          <path
            d="M24.4864 37.3679C25.2644 37.5719 26.0604 37.1059 26.2644 36.3259C26.4684 35.5479 26.0024 34.7519 25.2224 34.5479C24.4424 34.3439 23.6484 34.8099 23.4444 35.5899C23.2404 36.3679 23.7064 37.1639 24.4864 37.3679V37.3679Z"
            fill="url(#paint12_linear_241_813)"
          />
          <path
            d="M24.4782 42.6679C23.7022 42.8819 23.2462 43.6819 23.4582 44.4599C23.6722 45.2359 24.4722 45.6919 25.2482 45.4799C26.0242 45.2659 26.4802 44.4659 26.2682 43.6879C26.0542 42.9119 25.2542 42.4559 24.4762 42.6679H24.4782Z"
            fill="url(#paint13_linear_241_813)"
          />
          <path
            d="M27.8905 50.0719C27.3245 50.6439 27.3305 51.5679 27.9025 52.1319C28.4745 52.6979 29.3985 52.6919 29.9625 52.1199C30.5285 51.5479 30.5225 50.6239 29.9505 50.0599C29.3785 49.4939 28.4545 49.4999 27.8905 50.0719Z"
            fill="url(#paint14_linear_241_813)"
          />
          <path
            d="M36.3289 53.7359C35.5509 53.5319 34.7549 53.9979 34.5509 54.7779C34.3469 55.5559 34.8129 56.3519 35.5929 56.5559C36.3729 56.7599 37.1669 56.2939 37.3709 55.5139C37.5749 54.7359 37.1089 53.9399 36.3289 53.7359V53.7359Z"
            fill="url(#paint15_linear_241_813)"
          />
          <path
            d="M43.6882 53.7319C42.9122 53.9459 42.4562 54.7459 42.6682 55.5239C42.8822 56.2999 43.6822 56.7559 44.4602 56.5439C45.2382 56.3319 45.6922 55.5299 45.4802 54.7519C45.2662 53.9759 44.4662 53.5199 43.6882 53.7319Z"
            fill="url(#paint16_linear_241_813)"
          />
          <path
            d="M50.0604 50.048C49.4944 50.62 49.5004 51.544 50.0724 52.108C50.6444 52.674 51.5684 52.668 52.1324 52.096C52.6984 51.524 52.6924 50.6 52.1204 50.036C51.5484 49.47 50.6244 49.476 50.0604 50.048Z"
            fill="url(#paint17_linear_241_813)"
          />
          <path
            d="M55.5144 42.6319C54.7364 42.4279 53.9404 42.8939 53.7364 43.6739C53.5324 44.4519 53.9984 45.2479 54.7784 45.4519C55.5584 45.6559 56.3524 45.1899 56.5564 44.4099C56.7604 43.6319 56.2944 42.8359 55.5144 42.6319V42.6319Z"
            fill="url(#paint18_linear_241_813)"
          />
          <path
            d="M55.5226 37.332C56.2986 37.118 56.7546 36.318 56.5426 35.54C56.3286 34.764 55.5286 34.308 54.7526 34.52C53.9766 34.734 53.5206 35.534 53.7326 36.312C53.9466 37.088 54.7466 37.544 55.5246 37.332H55.5226Z"
            fill="url(#paint19_linear_241_813)"
          />
          <path
            d="M52.11 29.928C52.676 29.356 52.67 28.432 52.098 27.868C51.526 27.304 50.602 27.308 50.038 27.88C49.472 28.452 49.478 29.376 50.05 29.94C50.622 30.506 51.546 30.5 52.11 29.928Z"
            fill="url(#paint20_linear_241_813)"
          />
          <path
            d="M43.672 26.2639C44.45 26.4679 45.246 26.0019 45.45 25.2219C45.654 24.4439 45.188 23.6479 44.408 23.4439C43.628 23.2399 42.834 23.7059 42.63 24.4859C42.426 25.2639 42.892 26.0599 43.672 26.2639V26.2639Z"
            fill="url(#paint21_linear_241_813)"
          />
          <path
            d="M36.3127 26.268C37.0887 26.054 37.5447 25.254 37.3327 24.476C37.1187 23.7 36.3187 23.244 35.5407 23.456C34.7647 23.67 34.3087 24.47 34.5207 25.248C34.7347 26.024 35.5347 26.48 36.3127 26.268Z"
            fill="url(#paint22_linear_241_813)"
          />
          <path
            d="M29.94 29.952C30.506 29.38 30.5 28.456 29.928 27.892C29.356 27.326 28.432 27.332 27.868 27.904C27.302 28.476 27.308 29.4 27.88 29.964C28.452 30.53 29.376 30.524 29.94 29.952Z"
            fill="url(#paint23_linear_241_813)"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_241_813"
            x="3.8002"
            y="3.79995"
            width="75.5996"
            height="75.6001"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_241_813"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_241_813"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_241_813"
            x1="39.1487"
            y1="28.8378"
            x2="40.9082"
            y2="30.856"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_241_813"
            x1="34.0892"
            y1="30.1498"
            x2="35.8487"
            y2="32.1681"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_241_813"
            x1="30.3626"
            y1="33.8158"
            x2="32.1221"
            y2="35.8341"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_241_813"
            x1="28.971"
            y1="38.8559"
            x2="30.7305"
            y2="40.8741"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_241_813"
            x1="30.2825"
            y1="43.9157"
            x2="32.042"
            y2="45.9339"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_241_813"
            x1="33.9486"
            y1="47.6398"
            x2="35.708"
            y2="49.658"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_241_813"
            x1="38.9886"
            y1="49.0358"
            x2="40.7481"
            y2="51.054"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_241_813"
            x1="44.0491"
            y1="47.7218"
            x2="45.8086"
            y2="49.7401"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_241_813"
            x1="47.7728"
            y1="44.0558"
            x2="49.5323"
            y2="46.074"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_241_813"
            x1="49.1673"
            y1="39.0177"
            x2="50.9268"
            y2="41.0359"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint10_linear_241_813"
            x1="47.8548"
            y1="33.9557"
            x2="49.6143"
            y2="35.974"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint11_linear_241_813"
            x1="44.1888"
            y1="30.2296"
            x2="45.9483"
            y2="32.2479"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint12_linear_241_813"
            x1="23.8066"
            y1="34.7608"
            x2="25.7859"
            y2="37.0312"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint13_linear_241_813"
            x1="23.8161"
            y1="42.8768"
            x2="25.7956"
            y2="45.1458"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint14_linear_241_813"
            x1="27.8795"
            y1="49.8998"
            x2="29.8573"
            y2="52.1683"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint15_linear_241_813"
            x1="34.913"
            y1="53.9488"
            x2="36.8923"
            y2="56.2192"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint16_linear_241_813"
            x1="43.0264"
            y1="53.9407"
            x2="45.0057"
            y2="56.2112"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint17_linear_241_813"
            x1="50.0494"
            y1="49.8758"
            x2="52.0272"
            y2="52.1444"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint18_linear_241_813"
            x1="54.0986"
            y1="42.8448"
            x2="56.0779"
            y2="45.1151"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint19_linear_241_813"
            x1="54.0905"
            y1="34.7288"
            x2="56.07"
            y2="36.9979"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint20_linear_241_813"
            x1="50.027"
            y1="27.7085"
            x2="52.0041"
            y2="29.977"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint21_linear_241_813"
            x1="42.9921"
            y1="23.6568"
            x2="44.9714"
            y2="25.9272"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint22_linear_241_813"
            x1="34.8789"
            y1="23.6649"
            x2="36.8582"
            y2="25.9353"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint23_linear_241_813"
            x1="27.8571"
            y1="27.7318"
            x2="29.8348"
            y2="30.0004"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
}
export default siren;
